<template>
    <q-btn
        flat
        icon="mdi-menu"
        :class="buttonclass"
    >
        <q-menu
            v-model="showingMenu"
            anchor="bottom left"
            self="top left"
            :close-on-content-click="false"
            @update:model-value="(v) => { if (!v) command = null }"
        >
            <q-list dense class="overflow-y-auto" style="max-height: 600px;">
                <q-item v-if="debugMode && !hideColumSelector" clickable v-ripple @click="showColumnSelector">
                    <q-item-section avatar>
                        <q-icon name="mdi-view-grid-plus" />
                    </q-item-section>
                    <q-item-section>{{ Translate('Show Column Selector') }}</q-item-section>
                </q-item>

                <q-item v-if="debugMode" clickable v-ripple @click="showDataFilters">
                    <q-item-section avatar>
                        <q-icon name="mdi-filter" />
                    </q-item-section>
                    <q-item-section>{{ Translate('Show Data Filters') }}</q-item-section>
                </q-item>

                <q-separator v-if="debugMode" />

                <q-item clickable v-ripple @click="showAllColumns">
                    <q-item-section avatar />
                    <q-item-section>{{ Translate('Show all columns') }}</q-item-section>
                </q-item>

                <q-separator />

                <q-item
                    v-for="(item,i) in items"
                    :key="i"
                    clickable
                    v-ripple
                    @click="toggleColumnVisible(item)"
                >
                    <q-item-section avatar>
                        <q-icon v-if="!isHidden(item)" name="mdi-check" size="xs" />
                    </q-item-section>
                    <q-item-section>{{ item.Title }}</q-item-section>
                </q-item>
            </q-list>
        </q-menu>
    </q-btn>
</template>

<script>
    import common from './common.js';
    import methods from '@/Shared/methods';
    import { QBtn, QMenu, QList, QItem, QItemSection, QIcon, QSeparator } from 'quasar';

    export default {
        components: { QBtn, QMenu, QList, QItem, QItemSection, QIcon, QSeparator },
        data: function () {
            return {
                command: null,
                columns: [],
                selection: [],

                showingMenu: false,
                hiddencols: {},
            }
        },
        props: {
            column_list: {
                type: Array
            },
            column_order: null,
            column_default_visibility: null,
            columnDefs: null,
            debugMode: null,
            setColumnsVisible: null,

            hideColumSelector: null,

            btnclass: null,
        },
        created() {
            this.columns = this.column_list;
            this.hiddencols = { ...this.column_default_visibility };
        },
        computed: {
            buttonclass: function () {
                return { 'mt-0': true, 'ml-0': true, 'mr-2': true, 'mb-0': true, ...this.btnclass };
            },
            items: function () {
                if (!this.column_list?.length)
                    return [];

                const order = this.column_order || [];
                const seen = new Set();
                const result = [];

                const toItem = (col) => ({
                    ColId: col.ColId,
                    Title: col.Title,
                    Hidden: !!this.column_default_visibility[col.ColId],
                });

                for (const colId of order) {
                    const col = this.column_list.find(a => a.ColId == colId);
                    if (col && !seen.has(col.ColId)) {
                        result.push(toItem(col));
                        seen.add(col.ColId);
                    }
                }

                for (const col of this.column_list) {
                    if (!seen.has(col.ColId)) {
                        result.push(toItem(col));
                        seen.add(col.ColId);
                    }
                }

                return result;
            }
        },
        methods: {
            ...methods,
            isHidden(item) {
                const cdef = this.columnDefs?.find(a => a.colId === item.ColId);
                if (cdef)
                    return !!cdef.hide;
                return !!this.hiddencols[item.ColId];
            },
            toggleColumnVisible(item) {
                const currentlyHidden = this.isHidden(item);
                const next = { ...this.hiddencols };
                if (currentlyHidden)
                    delete next[item.ColId];
                else
                    next[item.ColId] = true;
                this.hiddencols = next;

                console.log(`toggleColumnVisible(col:${item.ColId}, value:${!currentlyHidden})`);
                this.setColumnsVisible([item.ColId], currentlyHidden);
            },
            showColumnSelector() {
                this.showingMenu = false;
                this.$emit('showcolumnselector');
            },
            showDataFilters() {
                this.showingMenu = false;
                this.$emit('showdatafilters');
            },
            showAllColumns() {
                this.showingMenu = false;
                this.hiddencols = {};
                this.setColumnsVisible(this.column_list.map(a => a.ColId), true);
            },
        }
    }
</script>

<style scoped>
</style>
